var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"mobile-header flex--align-center bold"},[_vm._t("back-button",function(){return [_c('div',{staticClass:"mobile-header__icon icon-arrow-long-left custom-icon",on:{"click":_vm.returnToPreviousPage}})]}),_vm._t("header-title"),_vm._t("header-dropdown")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }